// @flow
import * as React from 'react';

const MoreFeatures = () => <p>More features</p>;

export default MoreFeatures;
